import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { getDiamondRainHistory, getDiamondRainStats } from "../../../store/diamondRainHistory/action";
import dayjs from "dayjs";

import { useAccess, FEATURES } from "../../../hooks/useAccess";

//MUI icon
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

//pagination
import Pagination from "../../../pages/Pagination";

//Date Range Picker
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
//Calendar Css
import $ from "jquery";

const DiamondRainHistory = (props) => {
    const { diamondRainHistory, pagination, diamondRainStats } = useSelector(
        (state) => state.diamondRainHistory
    );

    const [data, setData] = useState([]);
    const [date, setDate] = useState([]);
    const [sDate, setsDate] = useState("ALL");
    const [eDate, seteDate] = useState("ALL");

    const [activePage, setActivePage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(20);

    const { canView } = useAccess();

    useEffect(() => {
        props.getDiamondRainHistory(activePage, rowsPerPage, sDate, eDate);
        props.getDiamondRainStats(sDate, eDate);
    }, [activePage, rowsPerPage, sDate, eDate]);

    useEffect(() => {
        setData(diamondRainHistory);
    }, [diamondRainHistory]);

    useEffect(() => {
        $("#card").click(() => {
            $("#datePicker").toggleClass("collapse");
        });
    }, []);

    useEffect(() => {
        if (date.length === 0) {
            setDate([
                {
                    startDate: new Date(),
                    endDate: new Date(),
                    key: "selection",
                },
            ]);
        }
        $("#datePicker");
        setData(diamondRainHistory);
    }, [date, diamondRainHistory]);

    const getAllData = () => {
        setActivePage(1);
        setsDate("ALL");
        seteDate("ALL");
        $("#datePicker");
    };

    const collapsedDatePicker = () => {
        $("#datePicker").toggleClass("collapse");
    };

    const handlePageChange = (pageNumber) => {
        setActivePage(pageNumber);
    };

    const handleRowsPerPage = (value) => {
        setActivePage(1);
        setRowsPerPage(value);
    };

    const handleRefresh = () => {
        props.getDiamondRainHistory(activePage, rowsPerPage, sDate, eDate);
        props.getDiamondRainStats(sDate, eDate);
    };

    return (
        <>
            <div className="page-title">
                <div className="row">
                    <div className="col-12 col-md-6 order-md-1 order-last">
                        <h3 className="mb-3 text-white">Diamond Rain History</h3>
                    </div>
                    <div className="col-12 col-md-6 order-md-2 order-first">
                        <nav
                            aria-label="breadcrumb"
                            className="breadcrumb-header float-start float-lg-end"
                        >
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to="/admin/dashboard" className="text-danger">
                                        Dashboard
                                    </Link>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">
                                    Diamond Rain History
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>

            {/* Stats Cards */}
            <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12">
                    <div className="row">
                        {canView(FEATURES.GAME_DIAMOND_RAIN_SUMMARY_TOTAL_GAMES) && (
                            <div className="col-lg-3 col-md-4 col-sm-6">
                                <div className="card stats-card">
                                    <div className="card-body">
                                        <div className="stats-info">
                                            <h5 className="card-title">
                                                {diamondRainStats?.totalRains || 0}
                                            </h5>
                                            <p className="stats-text">Total Rains</p>
                                        </div>
                                        <div className="stats-icon">
                                            <i className="material-icons">grain</i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {canView(FEATURES.GAME_DIAMOND_RAIN_SUMMARY_DIAMOND_SPENT) && (
                            <div className="col-lg-3 col-md-4 col-sm-6">
                                <div className="card stats-card">
                                    <div className="card-body">
                                        <div className="stats-info">
                                            <h5 className="card-title">
                                                {diamondRainStats?.totalDiamondsSent?.toLocaleString() || 0}
                                            </h5>
                                            <p className="stats-text">Total Diamonds Sent</p>
                                        </div>
                                        <div className="stats-icon">
                                            <i className="material-icons">send</i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {canView(FEATURES.GAME_DIAMOND_RAIN_SUMMARY_DIAMONDS_WON) && (
                            <div className="col-lg-3 col-md-4 col-sm-6">
                                <div className="card stats-card">
                                    <div className="card-body">
                                        <div className="stats-info">
                                            <h5 className="card-title">
                                                {diamondRainStats?.totalDiamondsGrabbed?.toLocaleString() || 0}
                                            </h5>
                                            <p className="stats-text">Total Diamonds Grabbed</p>
                                        </div>
                                        <div className="stats-icon">
                                            <i className="material-icons">stars</i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {canView(FEATURES.GAME_DIAMOND_RAIN_SUMMARY_DIAMONDS_REFUNDED) && (
                            <div className="col-lg-3 col-md-4 col-sm-6">
                                <div className="card stats-card">
                                    <div className="card-body">
                                        <div className="stats-info">
                                            <h5 className="card-title">
                                                {diamondRainStats?.diamondsReturned?.toLocaleString() || 0}
                                            </h5>
                                            <p className="stats-text">Diamonds Returned</p>
                                        </div>
                                        <div className="stats-icon">
                                            <i className="material-icons">keyboard_return</i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col">
                    <div className="card">
                        <div className="card-header pb-0">
                            <div className="row my-3">
                                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-8 float-left">
                                    <div className="text-left align-sm-left d-md-flex d-lg-flex justify-content-start">
                                        <button
                                            className="btn btn-info"
                                            style={{ marginRight: 5 }}
                                            onClick={getAllData}
                                        >
                                            All
                                        </button>
                                        <button
                                            className="btn btn-success"
                                            style={{ marginRight: 5 }}
                                            onClick={handleRefresh}
                                        >
                                            <i className="fas fa-sync-alt"></i> Refresh
                                        </button>
                                        <button
                                            className="collapsed btn btn-info ml-5"
                                            value="check"
                                            data-toggle="collapse"
                                            data-target="#datePicker"
                                            onClick={collapsedDatePicker}
                                        >
                                            Analytics
                                            <ExpandMoreIcon />
                                        </button>
                                        <p style={{ paddingLeft: 10 }} className="my-2 ">
                                            {sDate !== "ALL" && sDate + " to " + eDate}
                                        </p>
                                    </div>
                                </div>

                                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4 float-right">
                                    <div className="d-flex justify-content-end mt-3">
                                        <span className="text-danger">
                                            Total Records:
                                            <span className="text-info">&nbsp;&nbsp;{pagination?.totalRecords || 0}</span>
                                        </span>
                                    </div>
                                </div>
                                <div
                                    id="datePicker"
                                    className="collapse mt-5 pt-5"
                                    aria-expanded="false"
                                >
                                    <div className="container table-responsive">
                                        <div key={JSON.stringify(date)}>
                                            <DateRangePicker
                                                onChange={(item) => {
                                                    setDate([item.selection]);
                                                    const dayStart = dayjs(
                                                        item.selection.startDate
                                                    ).format("YYYY-MM-DD");
                                                    const dayEnd = dayjs(item.selection.endDate).format(
                                                        "YYYY-MM-DD"
                                                    );
                                                    setActivePage(1);
                                                    setsDate(dayStart);
                                                    seteDate(dayEnd);
                                                }}
                                                showSelectionPreview={true}
                                                moveRangeOnFirstSelection={false}
                                                ranges={date}
                                                direction="horizontal"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card-body card-overflow">
                            <table className="table table-striped" style={{ borderCollapse: "collapse" }}>
                                <thead className="text-center">
                                    <tr>
                                        <th>No</th>
                                        <th>Sender</th>
                                        <th>Unique ID</th>
                                        <th>Room</th>
                                        <th>Diamonds Sent</th>
                                        <th>Diamonds Grabbed</th>
                                        <th>Grab Rate</th>
                                        <th>Participants</th>
                                        <th>Schedule (min)</th>
                                        <th>Date</th>
                                    </tr>
                                </thead>
                                <tbody className="text-center">
                                    {data?.length > 0 ? (
                                        data?.map((record, index) => {
                                            const recordDate = dayjs(record?.createdAt).format("YYYY-MM-DD");
                                            const recordTime = dayjs(record?.createdAt).format("HH:mm:ss");
                                            const grabRate = record?.diamonds > 0
                                                ? ((record?.diamondsGrabbed / record?.diamonds) * 100).toFixed(2)
                                                : 0;

                                            return (
                                                <React.Fragment key={record?._id}>
                                                    <tr
                                                        data-toggle="collapse"
                                                        data-target={`#participantDetails${index}`}
                                                        className="accordion-toggle pointer-cursor"
                                                    >
                                                        <td>{(activePage - 1) * rowsPerPage + index + 1}</td>
                                                        <td>
                                                            <div className="d-flex align-items-center justify-content-center">
                                                                <img
                                                                    src={record?.sender?.image}
                                                                    alt=""
                                                                    style={{
                                                                        width: "40px",
                                                                        height: "40px",
                                                                        borderRadius: "50%",
                                                                        objectFit: "cover",
                                                                        marginRight: "10px"
                                                                    }}
                                                                />
                                                                <span>{record?.sender?.name}</span>
                                                            </div>
                                                        </td>
                                                        <td>{record?.sender?.uniqueId}</td>
                                                        <td>{record?.roomId?.roomName || "N/A"}</td>
                                                        <td>{parseInt(record?.diamonds).toLocaleString()}</td>
                                                        <td>{record?.diamondsGrabbed?.toLocaleString()}</td>
                                                        <td>{grabRate}%</td>
                                                        <td>{record?.userCount || record?.participants?.length || 0}</td>
                                                        <td>{record?.schedule}</td>
                                                        <td>
                                                            <div>{recordDate}</div>
                                                            <div className="text-muted">{recordTime}</div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan="10" className="hiddenRow">
                                                            <div
                                                                id={`participantDetails${index}`}
                                                                className="accordian-body collapse"
                                                            >
                                                                <div className="p-3">
                                                                    <h6 className="text-danger mb-3">Participants ({record?.participants?.length || 0})</h6>
                                                                    {record?.participants?.length > 0 ? (
                                                                        <div className="row">
                                                                            <div className="col-md-12">
                                                                                <div className="card bg-dark border border-secondary">
                                                                                    <div className="card-body p-2">
                                                                                        <table className="table table-sm table-borderless mb-0">
                                                                                            <thead>
                                                                                                <tr>
                                                                                                    <th className="text-white">#</th>
                                                                                                    <th className="text-white">User</th>
                                                                                                    <th className="text-white">Unique ID</th>
                                                                                                    <th className="text-white">Diamonds Grabbed</th>
                                                                                                </tr>
                                                                                            </thead>
                                                                                            <tbody>
                                                                                                {record.participants.map((participant, pIndex) => (
                                                                                                    <tr key={participant._id}>
                                                                                                        <td className="text-white">{pIndex + 1}</td>
                                                                                                        <td>
                                                                                                            <div className="d-flex align-items-center">
                                                                                                                <img
                                                                                                                    src={participant?.user?.image}
                                                                                                                    alt=""
                                                                                                                    style={{
                                                                                                                        width: "30px",
                                                                                                                        height: "30px",
                                                                                                                        borderRadius: "50%",
                                                                                                                        objectFit: "cover",
                                                                                                                        marginRight: "10px"
                                                                                                                    }}
                                                                                                                    onError={(e) => {
                                                                                                                        e.target.src = "https://devadmin.vibelynk.com/storage/male.png";
                                                                                                                    }}
                                                                                                                />
                                                                                                                <span className="text-white">{participant?.user?.name}</span>
                                                                                                            </div>
                                                                                                        </td>
                                                                                                        <td className="text-info">{participant?.user?.uniqueId}</td>
                                                                                                        <td className="text-success">{participant?.diamondsGrabbed?.toLocaleString()}</td>
                                                                                                    </tr>
                                                                                                ))}
                                                                                            </tbody>
                                                                                        </table>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ) : (
                                                                        <p className="text-white">No participants</p>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </React.Fragment>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan="10" align="center">
                                                Nothing to show!!
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            <Pagination
                                activePage={activePage}
                                rowsPerPage={rowsPerPage}
                                userTotal={pagination?.totalRecords || 0}
                                handleRowsPerPage={handleRowsPerPage}
                                handlePageChange={handlePageChange}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default connect(null, { getDiamondRainHistory, getDiamondRainStats })(DiamondRainHistory);
